// 本地存储方式：推荐使用 sessionStorage（页面刷新失效）
export function getToken() {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
}

export function setToken(token, remember = false) {
  if (remember) {
    localStorage.setItem("token", token);
  } else {
    sessionStorage.setItem("token", token);
  }
}

export function removeToken() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
}

export function getUserName() {
  return sessionStorage.getItem("userName") || localStorage.getItem("userName");
}

export function setUserName(userName, remember = false) {
  if (remember) {
    localStorage.setItem("userName", userName);
  } else {
    sessionStorage.setItem("userName", userName);
  }
}

export function removeUserName() {
  localStorage.removeItem("userName");
  sessionStorage.removeItem("userName");
}
